/// <amd-module name="Core/Medius.Core.Web/Scripts/components/taskHandling/shared/modals/rejectManagementWizard/reclassifyTypeModal"/>
import * as React from "react";
import { Checkbox, CheckboxGroup, FlexLayout, Notification } from "@medius/ui-controls";
import { getPropertyTranslation, translate } from "Core/Medius.Core.Web/Scripts/lib/globalization";

export interface ReclassifyTypeModalProps{
    possibleReclassifyTypeList: string[];
    targetDocumentType: string;
    setTargetDocumentType: (type: string) => void;
}

export const ReclassifyTypeModal = ({ possibleReclassifyTypeList, targetDocumentType, setTargetDocumentType}: ReclassifyTypeModalProps) =>{

    return (      
        <FlexLayout direction="column" height="content">              
            <Notification feedbackType="info" title={translate("#Core/documentWillBeReclassified")} text={translate("#Core/originalDocumentTypeIsDefault")}/>
            <CheckboxGroup layout="column">
                {possibleReclassifyTypeList.map((type, index) => (
                    <Checkbox 
                        key={index} 
                        label={getPropertyTranslation("#" + type)} 
                        checked={type === targetDocumentType} 
                        onChange={() => setTargetDocumentType(type)} 
                        data-testid={`checkbox-target-type-${getPropertyTranslation("#" + type)}`} />
                ))}
            </CheckboxGroup>
        </FlexLayout>
    );
};